import { PlatformLocation } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { getCurrentUser } from '@fantaz/shared/auth';
import {
  CasualTournamentEntity,
  CurrentUser,
  EventSchedule,
  PrizeDetails,
} from '@fantaz/shared/data-access/models';
import { ShareService } from '@fantaz/shared/share';
import { LoggerService } from '@fantaz/shared/utils/log';
import {
  getRandomAdvertisement,
  loadAdvertisement,
} from '@fantaz/tournaments/data-access';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'fz-widget-advertisements',
  templateUrl: './advertisements.component.html',
  styleUrls: ['./advertisements.component.scss'],
})
export class AdvertisementsComponent implements OnInit {
  currentUser: CurrentUser | null | undefined;

  tournament: CasualTournamentEntity;

  advertisementTournament$: Observable<CasualTournamentEntity> =
    this.store.select(getRandomAdvertisement);

  @Output()
  share = new EventEmitter<Observable<CasualTournamentEntity>>();

  constructor(
    private readonly logger: LoggerService,
    private readonly router: Router,
    private store: Store,
    private platformLocation: PlatformLocation,
    private shareService: ShareService,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getCurrentUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.currentUser = user;
      });

    this.store.dispatch(loadAdvertisement());

    this.advertisementTournament$
      .pipe(untilDestroyed(this))
      .subscribe((tournament) => {
        this.tournament = tournament;
      });
  }

  get eventSchedule(): EventSchedule {
    const eventSchedule = this.tournament?.eventSchedules[0];
    return eventSchedule as EventSchedule;
  }

  get prizeDetail(): PrizeDetails | null {
    const prizeDetails = this.eventSchedule.prizeDetails;
    for (let i = 0; i < prizeDetails.length; i++) {
      if (prizeDetails[i].rank === 1) {
        return prizeDetails[i];
      }
    }

    return null;
  }

  onJoinButtonPress() {
    this.router.navigate([
      '/prizes',
      this.tournament.url,
      this.eventSchedule.uuid,
    ]);
  }

  onSharePress() {
    this.logger.log('[Casual Tournaments Share Tournament]', this.tournament);
    const baseURL = this.platformLocation.href.split('?')[0];
    let urlStr = `${baseURL}/${this.tournament.url}`;

    if (this.tournament.lifeExperience) {
      urlStr += `/${this.tournament.eventSchedules[0].uuid}`;

      if (this.tournament.metadata?.vip) {
        urlStr = `${window.location.origin}/vip/${this.tournament.url}`;
      }
    }

    const url = new URL(urlStr);
    this.shareService.share({
      title: 'FantaZ',
      text: 'Play Casual tournaments',
      url: url.toString(),
      currentUser: this.currentUser,
      image: this.tournament.game.imageUrl,
    });
  }
}
